import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class StatusService {


  constructor(private http: HttpClient) { }

  url = environment.serverAPI9 + "/api/status";

  newStatus(kitchenMaster: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, kitchenMaster)
  }

  Status(Page: number, size: number, sort: any, type: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  getAllLeadStatusDropDown(type: any): Observable<Object> {
    return this.http.get(`${this.url}/dropdown?type=${type}`);
  }

  StatusSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {

    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
  }
  syncStatusPageData() {
    return this.http.get(`${this.url}/page/sync`);
  }


  public responseCache = new Map();

  public getAllLeadStatusDropDownCache(): Observable<any> {

    const leadStatusFromCache = this.responseCache.get(`${this.url}/dropdown`);

    if (leadStatusFromCache) {
      return of(leadStatusFromCache);
    } else {
      return this.http.get<any>(`${this.url}/dropdown`).pipe(
        tap(leadStatus => this.responseCache.set(`${this.url}/dropdown`, leadStatus))
      );
    }

  }
}
